import React, { PropsWithChildren, useContext } from 'react'
import * as S from './styles'

export enum RateVariant {
  BASE,
  PRO,
  ENTERPRISE
}

export enum RateSize { 
  DEFAULT,
  SMALL
}

export type RateProps = {
  isActive?: boolean
  variant: RateVariant
  size?: RateSize
  onClick?: React.MouseEventHandler<HTMLElement>
}

export type RateItemProps = {
  isActive?: boolean
  variant?: RateVariant
  size?: RateSize
}

type RateContextType = {
  isActive: boolean
  variant: RateVariant
  size: RateSize
}

export const RateContext = React.createContext<RateContextType>({variant: RateVariant.BASE, isActive: false, size: RateSize.DEFAULT})

const Rate = ({children, variant, isActive = false, size = RateSize.DEFAULT, onClick}: PropsWithChildren<RateProps>) => {
  return (
      <RateContext.Provider value={{variant, isActive, size}}>
          <S.Rate variant={variant} size={size} onClick={onClick}>
              {children}
          </S.Rate>
      </RateContext.Provider>
  )
}

const Title = ({children}) => {
  const { isActive, size } = useContext(RateContext);

  return (<S.Title isActive={isActive} size={size}>{children}</S.Title>)
}

const Content = ({children}) => {
  const { isActive, variant, size } = useContext(RateContext);

  return (<S.Content isActive={isActive} variant={variant} size={size}>{children}</S.Content>)
}

const Description = ({children}) => {
  const { isActive, variant, size } = useContext(RateContext);

  return (<S.Description isActive={isActive} variant={variant} size={size}>{children}</S.Description>)
}

const Item = ({children}) => {
  return (<S.Item>{children}</S.Item>)
}

const Value = ({children}) => {
  const { isActive, variant, size } = useContext(RateContext);

  return (<S.Value isActive={isActive} variant={variant} size={size}>{children}</S.Value>)
}

const Text = ({children}) => {
  const { isActive, variant, size } = useContext(RateContext);

  return (<S.Text isActive={isActive} variant={variant} size={size}>{children}</S.Text>)
}

const Footer =  ({children}) => {
  return (<S.Footer>{children}</S.Footer>)
}

export const Button = ({children}) => {
  const { isActive, variant, size } = useContext(RateContext);

  return (<S.Button isActive={isActive} variant={variant} size={size}>{children}</S.Button>)
}

export default Object.assign(Rate, {
  Title: Title,
  Content: Content,
  Desc: Description,
  Item: Item,
  Value: Value,
  Text: Text,
  Footer: Footer,
  Button: Button
});